// extracted by mini-css-extract-plugin
export default {"medicsContainer":"Medics_medicsContainer__iy1O9","filters":"Medics_filters__7ZSQA","details":"Medics_details__Teebr"};